// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./controllers/marksmith"

import { registerTurboStreamActions } from "./turbo_stream_actions"

registerTurboStreamActions()
